import { registerIcons } from "@fluentui/react";
/**
 * Registers the SVG icon set with Fluent, so they can be used in <Icon> elements
 * @param {ISvgIconSet} iconSet
 */ export function initializeSvgIcons(iconSet) {
    const { icons } = iconSet;
    const subset = {
        style: {
            MozOsxFontSmoothing: "grayscale",
            WebkitFontSmoothing: "antialiased",
            fontStyle: "normal",
            fontWeight: "normal",
            speak: "none",
            display: "flex",
            alignItems: "center"
        },
        icons
    };
    registerIcons(subset);
}
